import React, { FC } from 'react';
import { useTranslations } from '@lang';
import WrappedSlider from '@common/components/WrappedSlider';
import { ContentParser } from '@common/components/ContentParser';
import { Link } from 'shared-routing';

import {
  FeaturedEntityContainer,
  FeaturedEntityFullWidthWrapper,
  DetailsColumn,
  Description,
  ShowAllButtonDesktopWrapper,
  ShowAllButtonMobileWrapper,
  ShowAllEntitiesButton,
  SliderWrapper,
  Title,
} from './FeaturedEntity.styles';

import { Entity } from './Entity';

type FeaturedEntityProps = {
  title: JSX.Element | string;
  route: string;
  entityListingRoute: string;
  description: string;
  items: any[];
  entityName: JSX.Element | string;
  params?: any;
  dataTestId?: string;
  isLoadingPrice?: boolean;
};

export const FeaturedEntity: FC<FeaturedEntityProps> = ({
  description = null,
  entityName,
  items,
  route,
  title,
  params = {},
  entityListingRoute,
  dataTestId,
  isLoadingPrice,
}) => {
  const { t } = useTranslations();

  return (
    <FeaturedEntityFullWidthWrapper>
      <FeaturedEntityContainer data-testid={dataTestId || `featured-entity-${route}`}>
        <DetailsColumn expanded={items?.length === 0}>
          <Title>{title}</Title>
          <Description>{description && <ContentParser text={description} />}</Description>
          <ShowAllButtonDesktopWrapper>
            <Link route={entityListingRoute} params={params}>
              <ShowAllEntitiesButton>
                {t('featuredEntity.showAll', { entityName })}
              </ShowAllEntitiesButton>
            </Link>
          </ShowAllButtonDesktopWrapper>
        </DetailsColumn>
        {items?.length > 0 && (
          <SliderWrapper quantity={4}>
            <WrappedSlider
              speed={300}
              variableWidth
              draggable={false}
              infinite={false}
              responsive={[
                {
                  breakpoint: 1200,
                  settings: {
                    draggable: true,
                    dots: false,
                    arrows: false,
                  },
                },
              ]}
            >
              {items.map((item) => (
                <Entity key={item.id} item={item} route={route} isLoadingPrice={isLoadingPrice} />
              ))}
            </WrappedSlider>
          </SliderWrapper>
        )}
        <ShowAllButtonMobileWrapper>
          <Link route={entityListingRoute} params={params}>
            <ShowAllEntitiesButton>
              {t('featuredEntity.showAll', { entityName })}
            </ShowAllEntitiesButton>
          </Link>
        </ShowAllButtonMobileWrapper>
      </FeaturedEntityContainer>
    </FeaturedEntityFullWidthWrapper>
  );
};
